var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPaymentIncompleteWarningIcon = function SvgPaymentIncompleteWarningIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24Z",
    fill: "#E8C32E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.99 39.81c-2.2 0-4.06-1.81-4.06-4.02 0-2.21 1.87-3.98 4.06-3.98 2.19 0 4.06 1.78 4.06 3.98s-1.82 4.02-4.06 4.02Zm5.56-24.93L27.2 25.1c-.4 1.7-2.16 2.79-3.93 2.4-1.28-.25-2.21-1.26-2.48-2.4l-2.35-10.22c-.69-3 1.26-5.98 4.3-6.66 3.07-.68 6.11 1.21 6.81 4.21.24.83.18 1.68 0 2.45Z",
    fill: "#fff"
  })));
};
export default SvgPaymentIncompleteWarningIcon;